<!--
Author: Lsc
Date: 2019-8-30
Desc: 对账单信息组件，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-statement bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/info' }">
                    个人中心
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <div class="statement-content">
            <el-row class="statement-form">
                <el-col :span="24">
                    邮编：&emsp;{{ (statementInfo && statementInfo[0]) ? statementInfo[0][0].postcode : "--" }}
                </el-col>
                <el-col :span="24">
                    地址：&emsp;{{ (statementInfo && statementInfo[0]) ? statementInfo[0][0].address : "--" }}
                </el-col>
                <el-col :span="24">
                    客户名称：&emsp;{{ (statementInfo && statementInfo[0]) ? statementInfo[0][0].custfullname : "--" }}
                </el-col>
                <el-col :span="24">
                    经办人名称：&emsp;{{ (statementInfo && statementInfo[0]) ? statementInfo[0][0].transactornamestr : "--" }}
                </el-col>
            </el-row>
            <el-row class="statement-filter">
                <el-col :span="24">
                    <el-button
                        type="blue"
                        class="print-btn right"
                        v-on:click.prevent="printStatement"
                    >
                        打印对账单信息
                    </el-button>
                    <el-button
                        type="blue"
                        class="print-btn right"
                        v-on:click.prevent="getStatement"
                    >
                        查询
                    </el-button>
                    <div class="right">
                        <date-picker :date="dateSet" v-on:date-get="dateInterval" />
                    </div>
                    <span class="right date-text">
                        选择日期区间：
                    </span>
                </el-col>
            </el-row>
            <div class="table-title">
                历史持仓明细：
            </div>
            <el-table
                :data="statementInfo[2]"
                border
                style="width: 100%"
            >
                <el-table-column
                    prop="taaccountid"
                    label="基金账号"
                    width="120"
                    align="center"
                />
                <el-table-column
                    prop="transactionaccountid"
                    label="交易账号"
                    width="120"
                    align="center"
                />
                <el-table-column
                    prop="fundcode"
                    label="基金代码"
                    width="120"
                    align="center"
                />
                <el-table-column
                    prop="fundname"
                    label="基金名称"
                    align="center"
                />
                <el-table-column
                    prop="navdate"
                    label="净值日期"
                    width="120"
                    align="center"
                />
                <el-table-column
                    prop="nav"
                    label="单位净值(元)"
                    width="120"
                    align="center"
                />
                <el-table-column
                    prop="holdfund"
                    label="持有份额(份)"
                    width="120"
                    align="center"
                />
                <el-table-column
                    prop="totalassert"
                    label="参考市值(元)"
                    width="120"
                    align="center"
                />
                <el-table-column
                    prop="dividendmethod"
                    label="分红方式"
                    width="120"
                    align="center"
                />
                <el-table-column
                    prop="depositcard"
                    label="关联银行卡"
                    width="120"
                    align="center"
                />
            </el-table>
            <div class="table-title">
                基金交易明细：
            </div>
            <el-table
                :data="statementInfo[1]"
                border
                style="width: 100%"
            >
                <el-table-column
                    prop="taaccountid"
                    label="基金账号"
                    width="120"
                    align="center"
                />
                <el-table-column
                    prop="transactionaccountid"
                    label="交易账号"
                    width="120"
                    align="center"
                />
                <el-table-column
                    prop="transactioncfmdate"
                    label="确认日期"
                    width="120"
                    align="center"
                />
                <el-table-column
                    prop="fundcode"
                    label="基金代码"
                    width="120"
                    align="center"
                />
                <el-table-column
                    prop="fundname"
                    label="基金名称"
                    align="center"
                />
                <el-table-column
                    prop="businesscode"
                    label="业务类型"
                    width="100"
                    align="center"
                />
                <el-table-column
                    prop="confirmedamount"
                    label="确认金额"
                    width="150"
                    align="center"
                />
                <el-table-column
                    prop="confirmedvol"
                    label="确认份额"
                    width="150"
                    align="center"
                />
                <el-table-column
                    prop="nav"
                    label="确认净值"
                    width="150"
                    align="center"
                />
                <el-table-column
                    prop="charge"
                    label="手续费(元)"
                    width="180"
                    align="center"
                />
                <el-table-column
                    prop="cmfresult"
                    label="确认状态"
                    width="120"
                    align="center"
                />
                <el-table-column
                    prop="depositcard"
                    label="关联银行卡"
                    width="120"
                    align="center"
                />
            </el-table>
            <el-row v-if="allPage - 0 >= Number(conf.PAGE_SIZE)" class="page-box">
                <el-pagination
                    :page-size="Number(conf.PAGE_SIZE)"
                    background
                    :current-page.sync="curPage"
                    layout="prev, pager, next"
                    :total="allPage"
                    v-on:current-change="dataReset"
                />
            </el-row>
            <div class="table-title">
                历史分红明细：
            </div>
            <el-table
                :data="statementInfo[3]"
                border
                style="width: 100%"
            >
                <el-table-column
                    prop="taaccountid"
                    label="基金账号"
                    width="120"
                    align="center"
                />
                <el-table-column
                    prop="transactionaccountid"
                    label="交易账号"
                    width="120"
                    align="center"
                />
                <el-table-column
                    prop="transactioncfmdate"
                    label="确认日期"
                    width="120"
                    align="center"
                />
                <el-table-column
                    prop="fundcode"
                    label="基金代码"
                    width="120"
                    align="center"
                />
                <el-table-column
                    prop="fundname"
                    label="基金简称"
                    align="center"
                />
                <el-table-column
                    prop="defdividendmethod"
                    label="分红方式"
                    width="120"
                    align="center"
                />
                <el-table-column
                    prop="confirmedamount"
                    label="分红金额"
                    width="120"
                    align="center"
                />
                <el-table-column
                    prop="confirmedvol"
                    label="红利再投份额"
                    width="120"
                    align="center"
                />
                <el-table-column
                    prop="nav"
                    label="确认净值"
                    width="120"
                    align="center"
                />
            </el-table>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import format from "date-fns/format";
import conf from "@/config/index";
import datePicker from "@/components/form/datePicker";
export default {
    name: "Statement",
    components: {
        datePicker
    },
    mixins: [mixin],
    data () {
        return {
            qryArea: {
                begindate: "", // 默认起始日期
                enddate: "", // 默认结束日期
                pagecount: "", // 分页条数
                pageoffset: "0", // 起始页
                g_systemtype: "",
                token: ""
            },
            allPage: "0", // 所有数据条数
            dateArr: [],
            pickerOptions: {
                disabledDate: time => {
                    return time.getTime() > new Date().getTime();
                }
            },
            statementInfo: [],
            tableData: [],
            curPage: 1,
            dateSet: { type: "2", min: "1990-01-01", size: "media",val: [] },
            conf: {} // 初始化配置文件内容
        };
    },
    mounted () {
        this.nowDate = format(new Date(), "YYYYMMDD");
        this.dateSet.max = this.$util.fmtDate(this.nowDate);
        this.qryArea.begindate = this.$util.getBeginDate(format(new Date(), "YYYYMMDD"), 1);
        this.qryArea.enddate = this.nowDate;
        const _x = this.$util.fmtDate(this.qryArea.begindate);
        const _y = this.$util.fmtDate(this.qryArea.enddate);
        this.dateSet.val = [_x,_y];
        this.$set(this.qryArea, "pagecount", this.$util.getConfig().const.PAGE_SIZE);
        this.getStatement();
    },
    created () {
        this.conf = this.$util.getConfig().const;
    },
    methods: {
        dateInterval (val) {
            this.qryArea.begindate = this.$util.isEmpty(val.beginDate) ? "" : val.beginDate.replace(/-/g, "");
            this.qryArea.enddate = this.$util.isEmpty(val.endDate) ? "" : val.endDate.replace(/-/g, "");
        },
        getStatement (val) {
            const _this = this;
            if(this.$util.isEmpty(this.qryArea.begindate) || this.$util.isEmpty(this.qryArea.enddate)){
                let _m = "请输入完整的日期范围";
                this.$alert(_m,"日期提示");
                return;
            }
            this.$util.request("acct/statements/list", this.qryArea, "GET", false).then(res => {
                if (res.data) {
                    _this.allPage = res.data[0][0].transTotal - 0;
                    _this.statementInfo = res.data;
                }
            });
        },
        dataReset (val) {
            if(this.$util.isEmpty(this.qryArea.begindate) || this.$util.isEmpty(this.qryArea.enddate)){
                let _m = "请输入完整的日期范围";
                this.$alert(_m,"日期提示");
                return;
            }
            this.$set(this.qryArea, "pageoffset", ((val - 1) * this.qryArea.pagecount).toString());
            const _this = this;
            this.$util.request("acct/statements/list", this.qryArea, "GET", false).then(res => {
                if (res.data) {
                    _this.allPage = res.data[0][0].transTotal - 0;
                    _this.statementInfo = res.data;
                }
            });
        },
        printStatement () {
            const _this = this;
            if(this.$util.isEmpty(this.qryArea.begindate) || this.$util.isEmpty(this.qryArea.enddate)){
                let _m = "请输入完整的日期范围";
                this.$alert(_m,"日期提示");
                return;
            }
            let _x = Object.assign(this.qryArea,{"pageoffset": "", "pagecount": ""});
            this.$set(_x, "g_systemtype", conf.systemtype);
            this.$set(_x, "token", _this.$cache.getSessionToken());
            this.$util.request("acct/statements/download", _x, "GET", false, true).then(res => {
                this.download(res.data);
            });
            /* const getRootPath = function() {
                return (
                    window.location.protocol + "//" + window.location.host + conf.api.bankUrl
                );
            };
            let openUrl = getRootPath() + "/page/print.html?begindate=" + this.qryArea.begindate + "&enddate=" + this.qryArea.enddate + "&g_systemtype=" + conf.systemtype + "&token=" + this.$cache.getSessionToken();
            window.open(openUrl); */
        },
        // 下载文件
        download (data) {
            if (!data) {
                this.$message({
                    type: "warning",
                    message: "获取文件源失败"
                });
                return false;
            }
            let url = window.URL.createObjectURL(new Blob([data]));
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(new Blob([data]), "download.pdf");
                return false;
            }
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", "download.pdf");
            document.body.appendChild(link);
            link.click();
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-statement {
    padding-bottom: 50px;
    .date-text{line-height: 40px;margin-right: 10px;}
    .statement-content {
        padding: 0px 20px;
        .statement-form {
            padding: 10px 0px;
            border-bottom: 1px solid #ebebeb;
            >div {
                padding:5px;
            }
        }
        .statement-filter {
            text-align: right;
            padding: 10px 0px;
            .print-btn {
                margin-left: 10px;
            }
        }
        .table-title {
            padding: 10px 0px;
        }
    }
}
</style>
